export function formatDisplayDate(date, showYear = true) {
  if (!date) {
    return '';
  }

  const options = {
    day: 'numeric',
    month: 'numeric',
  };

  if (showYear) {
    options.year = 'numeric';
  }

  // WO-2365: We follow a specific three-character format for the month names.
  const monthNamesShort = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const dateTimeFormat = new Intl.DateTimeFormat('en-AU', options);
  const newDate = new Date(date);
  const formattedDate = dateTimeFormat.formatToParts(newDate);

  return formattedDate
    .map(part => {
      if (part.type === 'day') {
        return parseInt(part.value);
      } else if (part.type === 'month') {
        return monthNamesShort[parseInt(part.value) - 1];
      } else if (part.type === 'literal') {
        return ' ';
      }

      return part.value;
    })
    .join('');
}
